import React, { useState } from "react";
import api from "../api";
import { CloudUpload, CloudDownload, Shield, CheckCircle2, AlertTriangle } from "lucide-react";

/**
 * Settings Mirror to FTP.
 * Protects email templates + thresholds against DB resets on re-deploy
 * by snapshotting them to the same FTP used for backups.
 * On startup the backend auto-restores any field that's missing.
 */
export default function SettingsMirror() {
  const [busy, setBusy] = useState(null); // 'mirror' | 'restore' | null
  const [msg, setMsg] = useState(null);

  const run = async (kind) => {
    setBusy(kind); setMsg(null);
    try {
      const ep = kind === "mirror" ? "/settings/mirror-now" : "/settings/restore-from-ftp";
      const { data } = await api.post(ep);
      setMsg({ type: "ok", text: data.message || "Operazione completata." });
    } catch (e) {
      setMsg({ type: "err", text: e.response?.data?.detail || "Errore operazione." });
    } finally { setBusy(null); }
  };

  return (
    <div className="card mb-4" data-testid="settings-mirror-card">
      <div className="h-section mb-2" style={{display:"flex", alignItems:"center", gap:8}}>
        <Shield size={18}/> Protezione impostazioni da deploy
      </div>
      <div className="text-small text-muted mb-3" style={{lineHeight:1.55}}>
        Salva una copia delle impostazioni (template email, soglie, follow-up, video, regole PDF)
        sullo stesso server FTP del backup. Al prossimo avvio, se il database risultasse vuoto
        (es. dopo un redeploy che resetta MongoDB), i template vengono ripristinati automaticamente.
        <br/>
        <strong>Esegui "Salva ora su FTP"</strong> prima di ogni redeploy in produzione per essere
        al sicuro al 100%.
      </div>

      <div className="flex gap-2" style={{flexWrap:"wrap"}}>
        <button className="btn btn-primary" disabled={!!busy}
          onClick={()=>run("mirror")} data-testid="mirror-now-btn">
          {busy === "mirror" ? <span className="spinner"/> :
            <><CloudUpload size={14}/> Salva ora su FTP</>}
        </button>
        <button className="btn btn-secondary" disabled={!!busy}
          onClick={()=>run("restore")} data-testid="restore-settings-btn">
          {busy === "restore" ? <span className="spinner"/> :
            <><CloudDownload size={14}/> Ripristina da FTP (campi mancanti)</>}
        </button>
      </div>

      {msg && (
        <div className="card mt-3" style={{
          padding:10,
          background: msg.type==="ok" ? "#dcfce7" : "#fef2f2",
          borderLeft: `3px solid ${msg.type==="ok" ? "#15803d" : "#b91c1c"}`,
        }}>
          <div className="text-small" style={{
            color: msg.type==="ok" ? "#166534" : "#7f1d1d",
            display:"flex", alignItems:"center", gap:6,
          }}>
            {msg.type==="ok" ? <CheckCircle2 size={14}/> : <AlertTriangle size={14}/>}
            {msg.text}
          </div>
        </div>
      )}
    </div>
  );
}
